export const mobileBreakpoint = 1280;

type MobilePC = { mobile: string; PC: string };

export class PoleDlugosciJednoWWierszu {
    static readonly DATA = new PoleDlugosciJednoWWierszu('DATA', { mobile: '47%', PC: '56%' });
    static readonly CALA_DLUGOSC = new PoleDlugosciJednoWWierszu('CALA_DLUGOSC', { mobile: '67%', PC: 'calc(76% + -35px)' });
    static readonly SREDNIA_DLUGOSC = new PoleDlugosciJednoWWierszu('SREDNIA_DLUGOSC', { mobile: '31.121%', PC: '52.086%' });

    // private to disallow creating other instances of this type
    private constructor(private readonly key: string, public readonly value: MobilePC) {
    }

    toString() {
        return this.key;
    }
}

export class PoleDlugosciDwaWWierszu {
    static readonly LEWE = new PoleDlugosciDwaWWierszu(
        'LEWE',
        { formControl: { mobile: '56.463%', PC: '75.98%' }, label: { mobile: '37.19%', PC: '27.637%' }, field: { mobile: '55.117%', PC: '68.551%' } }
    );
    static readonly PRAWE = new PoleDlugosciDwaWWierszu(
        'PRAWE',
        { formControl: { mobile: '36.308%', PC: '21.02%' }, label: { mobile: '40.44%', PC: '46.583%' }, field: { mobile: '62px', PC: '62px' } }
    );
    static readonly LEWE_2 = new PoleDlugosciDwaWWierszu(
        'LEWE_2',
        { formControl: { mobile: '72.344%', PC: '79.896%' }, label: { mobile: '29.025%', PC: '26.284%' }, field: { mobile: '64.967%', PC: '70.092%' } }
    );
    static readonly PRAWE_2 = new PoleDlugosciDwaWWierszu(
        'PRAWE_2',
        { formControl: { mobile: '20.05%', PC: '17.105%' }, label: { mobile: '29.834%', PC: '23.308%' }, field: { mobile: '48.267%', PC: '76.711%' } }
    );
    static readonly LEWE_3 = new PoleDlugosciDwaWWierszu(
        'LEWE_3',
        { formControl: { mobile: '49.992%', PC: '45.995%' }, label: { mobile: '42.004%', PC: '45.653%' }, field: { mobile: '52.006%', PC: '47.835%' } }
    );
    static readonly PRAWE_3_BEZ_LABELA = new PoleDlugosciDwaWWierszu(
        'PRAWE_3_BEZ_LABELA',
        { formControl: { mobile: '26%', PC: '22%' }, label: { mobile: '0', PC: '0' }, field: { mobile: '100%', PC: '100%' } }
    );
    static readonly LEWE_LABEL_POMIEDZY = new PoleDlugosciDwaWWierszu(
        'LEWE_LABEL_POMIEDZY',
        { formControl: { mobile: '67.341%', PC: '83.229%' }, label: { mobile: '31.181%', PC: '25.23%' }, field: { mobile: '68.822%', PC: '74.773%' } }
    );
    static readonly PRAWE_LABEL_POMIEDZY = new PoleDlugosciDwaWWierszu(
        'PRAWE_LABEL_POMIEDZY',
        { formControl: { mobile: '20.653%', PC: '13.77%' }, label: { mobile: '', PC: '' }, field: { mobile: '46px', PC: '46px' } }
    );

    // private to disallow creating other instances of this type
    private constructor(private readonly key: string, public readonly value: { formControl: MobilePC, label: MobilePC, field: MobilePC }) {
    }

    toString() {
        return this.key;
    }
}

export enum InputTypes {
    Text = 'text',
    Number = 'number',
}